import FingerprintJS from "@fingerprintjs/fingerprintjs";

export default function useFingerprint() {
  const fpPromise = FingerprintJS.load();

  const getFingerprint = async () => {
    const fp = await fpPromise;
    return await fp.get();
  };

  return { getFingerprint };
}
